module.exports = __webpack_public_path__ + "static/media/InsomniaPack1.ca63fce3.png";